/* eslint-disable prettier/prettier */
import jwtDecode from "jwt-decode";
import appService from "@/service.js";


export const state = {
  accessToken: null,
  isLogged: false,
  username: null,
  nome: null,
  isAdmin: false,
  tokenExpireDate: null
};

export const mutations = {
  SET_LOGIN(state, payload) {       
    var token = payload.token;
    console.log("mutation SET_LOGIN: " + token);
    //$cookies.set("jwt", token, "1m"); /*eslint no-undef:*/ //1 mese cookie

    localStorage.setItem('jwt', token);
    appService.addAuthHeader(token);

    state.accessToken = token;
    var decodedToken = jwtDecode(token);
    state.isLogged = true;
    state.username = decodedToken.user;
    state.nome = decodedToken.nome;
    state.isAdmin = decodedToken.admin === 1;
  },
  SET_LOGOUT(state) {
    console.log("mutation SET_LOGOUT called");
    //$cookies.remove("jwt");    
    localStorage.removeItem('jwt')
    appService.removeAuthHeader();

    state.isLogged = false;
    state.accessToken = null;
    state.username = null;
    state.nome = null;
    state.isAdmin = false;
  }
};

export const actions = {
  login: function({ commit }, { username, password }) {
    console.log("action login called");    
    return appService
      .loginAsync(username, password)
      .then(res => {        
        commit("SET_LOGIN", res.data);      
    }).catch((error) => {
      console.log(error)
      throw error;
    });
  },
  //azione chiamata in home. se il token è scaduto, lo cancella automaticamente
  checkTokenExpired: function({ commit }) {
    if (state.accessToken) {
      var decoded = jwtDecode(state.accessToken);
      var timeNow = Math.floor(new Date().getTime() / 1000.0);
      var secondsLeft = decoded.exp - timeNow;
      if (secondsLeft <= 0) {
        commit("SET_LOGOUT");
      }
    }
  },
  verifyAuthStatus: function({ commit }) {
    console.log("store.user.verifyAuthStatus")
        
    var token = localStorage.getItem("jwt");
    if (token) {
      console.log("store.user.verifyAuthStatus, setting token : " + token)
      commit("SET_LOGIN", { token });
    }
  },
  logout: function({ commit }) {
    console.log("action logout called");

    appService.logout().then(() => {
      commit("SET_LOGOUT");
    });
  }
};

export const getters = {
  getUsername: state => {
    return state.username;
    // if (state.accessToken) {
    //   var decoded = jwtDecode(state.accessToken);
    //   return decoded.user;
    // }
  },
  getName: state => {
    return state.nome;
  },
  getToken: state => {
    return state.token;
  },
  isTokenStillValid: state => {
    if (state.accessToken) {
      var decoded = jwtDecode(state.accessToken);
      //console.log(decoded.exp);
      var expire_date = new Date(decoded.exp * 1000);
      console.log("token will expire at: " + decoded.exp + " - " + expire_date)
      return decoded.exp;
    }
  },
  isUserAdmin: state => {
    return state.isAdmin;
  },
  isLogged: state => {
    return state.isLogged;
  }
};
